import styled, { css } from "styled-components"

export default styled.button`
  ${({ primary }) =>
    primary &&
    css`
      border-radius: 20px;
      border: 2px solid ${({ theme }) => theme.mint};
      padding: 0.5rem 3.8rem;
      color: ${({ theme }) => theme.gray};
      font-family: ${({ theme }) => theme.body};
      font-weight: 700;
      background: transparent;
      margin: 0 auto;
      margin-left: 3.8rem;
      display: block;
      cursor: pointer;
      transition: all 300ms ease;
      &:hover,
      &:active {
        background-color: ${({ theme }) => theme.mint};
        color: #ffffff;
      }
    `}
`
